import React from 'react'
import { Link, useMatch } from 'react-router-dom'
import { Icon, l, PrimaryNavigation } from '@manychat/manyui'

import { linkURL } from 'utils/url'

import { useRouteNotifications } from './hooks/useRouteNotifications'
import { NavigationRoute } from './navigationRoutes'

interface NavItemProps {
  item: NavigationRoute
  expanded: boolean
  className?: string
  onClick: (item: NavigationRoute) => void
  mode?: 'link' | 'button'
}

export const NavItem = ({ item, expanded, onClick, className, mode = 'link' }: NavItemProps) => {
  const label = l.getString(item.label)
  const IconElement = React.createElement(Icon[item.icon])

  const { notificationCount, hasNotification, notificationColor } = useRouteNotifications(item.id)
  const matchesUrl = useMatch(':acc_id' + item.url + '/*')
  const isActive = item?.isActive ? item.isActive() : Boolean(matchesUrl)
  const href = linkURL(item.url)

  const commonProps = {
    icon: IconElement,
    className,
    collapsed: !expanded,
    notificationCount,
    notificationColor,
    hasNotification: Boolean(notificationCount) || hasNotification,
    tooltip: label,
    ariaLabel: label,
    selected: isActive,
    'data-test-id': item.testId,
  }

  if (mode === 'button') {
    return (
      <PrimaryNavigation.Item as="button" {...commonProps} onClick={() => onClick(item)}>
        {label}
      </PrimaryNavigation.Item>
    )
  }

  return (
    <PrimaryNavigation.Item
      as={Link}
      {...commonProps}
      to={href}
      state={item.state}
      onClick={() => onClick(item)}
    >
      {label}
    </PrimaryNavigation.Item>
  )
}
